module.exports = __webpack_public_path__ + "static/inbox-b820ab32d91952bc025b17eb26a1b625.jpg";